import useAcvStore from '@/composables/useAcvStore';

const getRewardsPointsLabel = async () => {
  let defaultText = 'Dealer Rewards Program';
  await useAcvStore().dispatch('refreshRewardsEnrollmentStatus');
  const map = useAcvStore().state.rewards.loyaltyMap;
  map.forEach((dealer, dealerId) => {
    if (dealerId === useAcvStore().getters.currentUser.defaultDealerId) {
      if (dealer.enrolledToRewards) {
        const pts = dealer.rewardPoints;
        if (pts > 0) {
          defaultText = `${pts} pts.`;
        } else {
          defaultText = '-- pts. (updating)';
        }
      }
    }
  });
  return defaultText;
};

export default getRewardsPointsLabel;
